import { Link } from "react-router-dom";
import useTable from "../../../../MainComponents/Hooks/useTable.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { useAuthState } from "../../../../MainComponents/GlobalContext.jsx";
import HelmetTags from "../../../../MainComponents/HelmetTags.jsx";
import { useQueryState } from "nuqs";
import { Segmented, Badge } from "antd";

function PurchaseRequests() {
  const AuthState = useAuthState();
  const [status, setStatus] = useQueryState("status", {
    defaultValue: "pending",
  });

  const table = useTable("purchaseRequests", "", "", status, "", status);

  return (
    <section className="h-auto w-full overflow-hidden px-20 py-20 dark:bg-dark dark:text-light sm:px-10">
      <HelmetTags title="طلبات الشراء | مسيو بلال عبدالله" />

      <div className="mb-16 flex flex-col items-end gap-10">
        <div className="flex w-full items-center justify-between">
          <h2 className="text-4xl font-bold md:text-center">طلبات الشراء</h2>

          <Segmented
            value={status}
            onChange={(value) => setStatus(value)}
            options={[
              {
                label: (
                  <span className="flex items-center gap-2 dark:text-light">
                    <Badge status="processing" />
                    قيد المراجعة
                  </span>
                ),
                value: "pending",
              },
              {
                label: (
                  <span className="flex items-center gap-2 dark:text-light">
                    <Badge status="success" />
                    تم القبول
                  </span>
                ),
                value: "approved",
              },
              {
                label: (
                  <span className="flex items-center gap-2 dark:text-light">
                    <Badge status="error" />
                    مرفوض
                  </span>
                ),
                value: "rejected",
              },
            ].reverse()}
            className="  dark:bg-dark border border-gray-300 dark:border-gray-700 rounded-xl p-1 text-lg shadow-sm"
          />
        </div>
      </div>

      <div className="h-fit w-full">{table}</div>
    </section>
  );
}

export default PurchaseRequests;
